/**
 * PRO-LEDSIGN — Mobile header menu + nested category accordions
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var mobileToggle = document.getElementById('mobile-menu-toggle');
    var mobileMenu = document.getElementById('mobile-menu');
    var desktopMegaQuery = window.matchMedia('(min-width: 1024px)');

    function isDesktopNav() {
      return desktopMegaQuery.matches;
    }

    function setSectionPanelOpen(panel, open) {
      if (!panel) return;
      if (open) {
        panel.removeAttribute('hidden');
        panel.classList.remove('hidden');
        panel.classList.add('is-open');
      } else {
        panel.classList.remove('is-open');
        panel.setAttribute('hidden', '');
        panel.classList.add('hidden');
      }
    }

    function isSectionPanelOpen(panel) {
      return panel && panel.classList.contains('is-open');
    }

    function getCategoryPanel(toggle) {
      if (!toggle) return null;
      var panelId = toggle.getAttribute('aria-controls');
      if (panelId) {
        var byId = document.getElementById(panelId);
        if (byId) return byId;
      }
      var accordion = toggle.closest('.mobile-category-accordion');
      return accordion ? accordion.querySelector('.mobile-category-accordion__panel') : null;
    }

    function isCategoryPanelOpen(panel) {
      return panel && panel.classList.contains('is-expanded');
    }

    function setCategoryPanelOpen(panel, open) {
      if (!panel) return;

      if (open) {
        panel.removeAttribute('hidden');
        panel.classList.remove('hidden');

        // Measure content height for smooth expand animation
        panel.style.maxHeight = '0px';
        panel.classList.add('is-expanded');

        window.requestAnimationFrame(function () {
          var inner = panel.querySelector('.mobile-category-accordion__panel-inner');
          var targetHeight = inner ? inner.scrollHeight : panel.scrollHeight;
          panel.style.maxHeight = targetHeight + 'px';
        });
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
        panel.classList.remove('is-expanded');

        window.requestAnimationFrame(function () {
          panel.style.maxHeight = '0px';
        });

        window.setTimeout(function () {
          if (!panel.classList.contains('is-expanded')) {
            panel.setAttribute('hidden', '');
            panel.classList.add('hidden');
            panel.style.maxHeight = '';
          }
        }, 320);
      }
    }

    function closeDesktopMegaMenus() {
      document.querySelectorAll('.nav-mega-group.is-mega-open').forEach(function (group) {
        group.classList.remove('is-mega-open');
        var trigger = group.querySelector('.nav-mega-trigger');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }

    function closeMobileCategories(container) {
      if (!container) return;
      container.querySelectorAll('.mobile-category-accordion__toggle[aria-expanded="true"]').forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        setCategoryPanelOpen(getCategoryPanel(toggle), false);
      });
    }

    function setMobileAccordionOpen(section, open) {
      if (!section) return;
      var header = section.querySelector('.mobile-accordion-header');
      var content = section.querySelector('.mobile-accordion-panel');
      if (!header || !content) return;
      header.setAttribute('aria-expanded', open ? 'true' : 'false');
      setSectionPanelOpen(content, open);
      if (!open) closeMobileCategories(content);
    }

    function setMobileCategoryOpen(toggle, open, closeSiblings) {
      if (!toggle) return;
      var panel = getCategoryPanel(toggle);
      if (!panel) return;

      if (closeSiblings) {
        var parent = toggle.closest('.mobile-accordion-panel');
        if (parent) {
          parent.querySelectorAll('.mobile-category-accordion__toggle').forEach(function (other) {
            if (other !== toggle && other.getAttribute('aria-expanded') === 'true') {
              other.setAttribute('aria-expanded', 'false');
              setCategoryPanelOpen(getCategoryPanel(other), false);
            }
          });
        }
      }

      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      setCategoryPanelOpen(panel, open);
    }

    function openMobileMenuPanel() {
      if (!mobileMenu) return;
      mobileMenu.classList.remove('hidden');
      mobileMenu.classList.add('flex');
      if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'true');
    }

    function openHeaderMegaMenu(target) {
      if (!target) return;

      window.scrollTo({ top: 0, behavior: 'smooth' });

      window.setTimeout(function () {
        if (isDesktopNav()) {
          closeDesktopMegaMenus();
          var group = document.querySelector('[data-nav-mega="' + target + '"]');
          if (group) {
            group.classList.add('is-mega-open');
            var trigger = group.querySelector('.nav-mega-trigger');
            if (trigger) {
              trigger.setAttribute('aria-expanded', 'true');
              trigger.focus({ preventScroll: true });
            }
          }
        } else {
          openMobileMenuPanel();
          document.querySelectorAll('[data-mobile-mega]').forEach(function (section) {
            setMobileAccordionOpen(section, section.getAttribute('data-mobile-mega') === target);
          });
          var activeSection = document.querySelector('[data-mobile-mega="' + target + '"]');
          if (activeSection) {
            var accordionHeader = activeSection.querySelector('.mobile-accordion-header');
            if (accordionHeader) accordionHeader.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          }
        }
      }, 350);
    }

    function resetMobileMenuAccordions() {
      if (!mobileMenu) return;
      mobileMenu.querySelectorAll('.mobile-accordion-header[aria-expanded="true"]').forEach(function (header) {
        header.setAttribute('aria-expanded', 'false');
        var section = header.closest('.mobile-accordion');
        var panel = section ? section.querySelector('.mobile-accordion-panel') : null;
        if (panel) {
          setSectionPanelOpen(panel, false);
          closeMobileCategories(panel);
        }
      });
    }

    if (mobileToggle && mobileMenu) {
      mobileToggle.addEventListener('click', function () {
        var willOpen = mobileMenu.classList.contains('hidden');
        mobileMenu.classList.toggle('hidden');
        mobileMenu.classList.toggle('flex');
        mobileToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        if (!willOpen) resetMobileMenuAccordions();
      });
    }

    if (mobileMenu) {
      mobileMenu.addEventListener('click', function (e) {
        var categoryToggle = e.target.closest('.mobile-category-accordion__toggle');
        if (categoryToggle) {
          e.preventDefault();
          e.stopPropagation();

          var panel = getCategoryPanel(categoryToggle);
          if (!panel) return;

          var willOpen = !isCategoryPanelOpen(panel);
          setMobileCategoryOpen(categoryToggle, willOpen, true);
          return;
        }

        var header = e.target.closest('.mobile-accordion-header');
        if (header) {
          e.stopPropagation();

          var section = header.closest('.mobile-accordion') || header.parentElement;
          var content = section ? section.querySelector('.mobile-accordion-panel') : header.nextElementSibling;
          if (!content) return;

          var willOpenSection = !isSectionPanelOpen(content);
          header.setAttribute('aria-expanded', willOpenSection ? 'true' : 'false');
          setSectionPanelOpen(content, willOpenSection);
          if (!willOpenSection) closeMobileCategories(content);
        }
      });
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('.js-open-header-mega')) return;

      if (mobileMenu && !mobileMenu.contains(e.target) && mobileToggle && !mobileToggle.contains(e.target)) {
        if (!mobileMenu.classList.contains('hidden')) {
          mobileMenu.classList.add('hidden');
          mobileMenu.classList.remove('flex');
          if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
          resetMobileMenuAccordions();
        }
      }

      if (!e.target.closest('.nav-mega-group')) {
        closeDesktopMegaMenus();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDesktopMegaMenus();
    });

    document.querySelectorAll('.js-open-header-mega').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openHeaderMegaMenu(btn.getAttribute('data-mega-menu'));
      });
    });

    window.ProLedsignNav = window.ProLedsignNav || {};
    window.ProLedsignNav.openHeaderMegaMenu = openHeaderMegaMenu;
  });
})();